import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export function Benefits() {
  return <section className="py-20 px-6 bg-white" data-id="element-5">
      <div className="max-w-4xl mx-auto" data-id="element-6">
        {/* Why it works */}
        <div className="mb-24 text-center max-w-2xl mx-auto" data-id="element-7">
          <h2 className="text-3xl font-serif text-charcoal mb-6" data-id="element-8">
            Por qué esto funciona cuando todo lo demás falla
          </h2>
          <p className="text-lg text-charcoal/80 mb-8" data-id="element-9">
            Porque no intenta convertirte en contadora. Te devuelve control con{' '}
            <span className="font-bold" data-id="element-10">una decisión</span>:
          </p>
          <div className="bg-cream px-8 py-6 rounded-xl inline-block shadow-sm" data-id="element-11">
            <p className="font-serif text-2xl text-forest italic whitespace-nowrap" data-id="element-12">
              "¿Cabe dentro del cap o no?"
            </p>
          </div>
          <p className="mt-8 text-lg text-charcoal/80" data-id="element-13">
            Y eso es lo único que tu cerebro necesita cuando estás saturada.
          </p>
        </div>

        {/* What's included */}
        <div className="grid md:grid-cols-2 gap-12 items-start mb-16" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-15">
            <h3 className="text-2xl font-serif text-charcoal mb-8" data-id="element-16">
              Dentro de "El Mapa de Pago en 10 Min" tendrás:
            </h3>
            <ul className="space-y-4" data-id="element-17">
              {['La rutina exacta de 10 minutos (paso a paso)', 'La plantilla de 1 página (imprimible)', 'Cómo manejar autopay + bills digitales sin caos', 'Cómo proteger esenciales por semana (sin adivinar el mes)', 'Cómo crear un buffer aunque sea pequeño (para evitar el castigo bancario)', 'Qué hacer cuando la vida golpea (escuela, enfermedad, sorpresa)', "Scripts anti-culpa para decir 'no hoy' sin romperte"].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/90" data-id="element-18">
                  <CheckCircle2 className="w-5 h-5 text-forest mt-1 flex-shrink-0" data-id="element-19" />
                  <span data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream p-8 rounded-2xl border border-warm-gray/10" data-id="element-21">
            <h3 className="text-xl font-serif text-forest mb-6" data-id="element-22">
              Bonos incluidos:
            </h3>
            <ul className="space-y-6" data-id="element-23">
              <li className="flex gap-4" data-id="element-24">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center text-xl shadow-sm flex-shrink-0" data-id="element-25">
                  📊
                </div>
                <div data-id="element-26">
                  <h4 className="font-bold text-charcoal" data-id="element-27">
                    Plantilla para Google Sheets
                  </h4>
                  <p className="text-sm text-warm-gray" data-id="element-28">
                    Para las que prefieren digital y fácil.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-29">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center text-xl shadow-sm flex-shrink-0" data-id="element-30">
                  🏷️
                </div>
                <div data-id="element-31">
                  <h4 className="font-bold text-charcoal" data-id="element-32">
                    "Fridge Card" imprimible
                  </h4>
                  <p className="text-sm text-warm-gray" data-id="element-33">
                    Tu cap semanal visible en el refri.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-34">
                <div className="bg-white w-12 h-12 rounded-full flex items-center justify-center text-xl shadow-sm flex-shrink-0" data-id="element-35">
                  ✅
                </div>
                <div data-id="element-36">
                  <h4 className="font-bold text-charcoal" data-id="element-37">
                    Checklist "Antes de gastar"
                  </h4>
                  <p className="text-sm text-warm-gray" data-id="element-38">
                    30 segundos para detener la compra impulsiva.
                  </p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-39">
          <Button scrollTo="checkout" data-id="element-40">Descarga el Mapa de Pago — $6.36</Button>
        </div>
      </div>
    </section>;
}